function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Modal
 * 
 */
import React, { Component } from 'react';
import './Modal.scss';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
class Modal extends Component {
  constructor(props) {
    super(props);
    // $FlowFixMe
    _defineProperty(this, "okRef", void 0);
    /**
     * handleKeydown
     */
    _defineProperty(this, "handleKeydown", e => {
      // $FlowFixMe
      const {
        key
      } = e;
      const {
        next
      } = this.props;
      const {
        focus
      } = this.state;
      if (focus && key === 'Enter') {
        next(e);
      }
    });
    /**
     * onFocus
     */
    _defineProperty(this, "onFocus", () => {
      this.setState({
        focus: true
      });
    });
    /**
     * onBlur
     */
    _defineProperty(this, "onBlur", () => {
      this.setState({
        focus: false
      });
    });
    _defineProperty(this, "focus", () => {
      if (this.okRef && this.okRef.current) {
        console.warn('set focus OK');
        this.okRef.current.focus();
      }
    });
    _defineProperty(this, "handleResize", () => {
      this.setState({
        width: window.innerWidth
      });
    });
    this.state = {
      focus: false,
      infoWidth: 250,
      width: window.innerWidth
    };
    this.okRef = /*#__PURE__*/React.createRef();
  }
  componentDidMount() {
    // $FlowFixMe
    document.addEventListener('keydown', this.handleKeydown);
    window.addEventListener('resize', this.handleResize);
    setTimeout(this.focus, 500);
  }
  componentWillUnmount() {
    // $FlowFixMe
    document.removeEventListener('keydown', this.handleKeydown);
    window.removeEventListener('resize', this.handleResize);
  }
  render() {
    const {
      name,
      next,
      show
    } = this.props;
    const {
      width
    } = this.state;
    if (!show) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      className: "Modal",
      style: {
        width
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "info",
        children: [/*#__PURE__*/_jsxs("div", {
          children: ["You will now be transferred to ", name, " for processing of your IDP on behalf of the AAA"]
        }), /*#__PURE__*/_jsx("div", {
          ref: this.okRef,
          className: "button",
          onClick: next,
          tabIndex: "0",
          role: "button",
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          children: "OK"
        })]
      })
    });
  }
}
_defineProperty(Modal, "defaultProps", {
  name: 'RACV',
  next: () => null,
  show: false
});
export default Modal;